import { inject, Service } from "@angular/core"
import { Observable } from "rxjs"
import { HttpClient } from "@angular/common/http"
import { Survey, PagedSurvey, CreateSurvey, ModifyObject } from "../models"
import { environment } from "src/environments/environment"

export interface ColumnFilter {
    field: string
    value: string
    matchMode: string
}

export interface GetSurveyPagedParams {
    search?: string
    sortField?: string
    sortDescending?: boolean
    page: number
    pageSize: number
    columnFilters?: ColumnFilter[]
}

@Service({ autoProvided: false })
export class SurveyService {
    private _http = inject(HttpClient)
    private _apiUrl = environment.apiBaseUrl + environment.endpointRoutes.surveys

    Get(): Observable<Survey[]> {
        return this._http.get<Survey[]>(this._apiUrl)
    }

    GetOne(masterId: string): Observable<Survey> {
        return this._http.get<Survey>(this.ByMasterIdUrl(masterId))
    }
    ByMasterIdUrl(masterId: string): string {
        return `${this._apiUrl}/${masterId}`
    }

    GetPaged(params: GetSurveyPagedParams): Observable<PagedSurvey> {
        const request = this.PagedRequest(params)
        return this._http.get<PagedSurvey>(request.url, { params: request.params })
    }
    PagedRequest(params: GetSurveyPagedParams): { url: string; params: Record<string, string> } {
        const httpParams: Record<string, string> = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        }
        if (params.search) httpParams["search"] = params.search
        if (params.sortField) httpParams["sortField"] = params.sortField
        if (params.sortDescending !== undefined) httpParams["sortDescending"] = params.sortDescending.toString()
        if (params.columnFilters?.length) httpParams["columnFilters"] = JSON.stringify(params.columnFilters)

        return { url: this._apiUrl + "/paged", params: httpParams }
    }

    Create(createSurvey: CreateSurvey): Observable<Survey> {
        return this._http.post<Survey>(this._apiUrl, createSurvey)
    }

    Modify(masterId: string, data: ModifyObject): Observable<Survey> {
        return this._http.patch<Survey>(this.ByMasterIdUrl(masterId), data)
    }

    Delete(masterId: string): Observable<string> {
        return this._http.delete<string>(this.ByMasterIdUrl(masterId))
    }
}
